
import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { FileCopySharp } from '@material-ui/icons';
//iconos
import { Add } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { TextField } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import { useParams } from 'react-router-dom';
import Badge from 'components/Badge/Badge';

//servicios
import { wsGet, wsUpdate, wsFindBy } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Periodo', accessor: 'periodo'},
  { Header: 'Categoria', accessor: 'categoria'},
  { Header: 'Linea', accessor: 'linea'},
  { Header: 'Familia', accessor: 'familia'},
  { Header: 'Producto', accessor: 'producto'},
  { Header: 'Tipo', accessor: 'type'},
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];
const permission = {
  store: 'INCENTIVOS_TIPO_INCENTIVOS_STORE',
  delete: 'INCENTIVOS_TIPO_INCENTIVOS_DELETED',
};
export default WithApp(function Colgate(props) {
  const { id } = useParams();
  const classes = useStyles();
  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [dataLoading, setDataLoading] = useState(false);
  const [cuotas, setCuotas] = useState([]);
  const [cuotasDetail, setCuotasDetail] = useState([]);

  const handleChange = (id, value) => {
    const index = cuotas.findIndex((item) => item.id == id);
    cuotas[index].cuota = value;
    setCuotas([...cuotas]);
  };
  
  async function getCuota(idCuotas) {
    setDataLoading(true);
    let response = await wsGet('sale/softy-grupo', idCuotas);
    setDataLoading(false);
    if (response.success) {
      setCuotas(response.data);
    }
  }

  async function listCuotaDetail() {
    setDataLoading(true);
    let response = await wsFindBy('sale/softy-grupo-detalle', { softy_grupo_id: id });
    setDataLoading(false);
    if (response.success) setCuotasDetail(response.data);
  }

  async function updateCuota(id, value) {
    setDataLoading(true);
    let response = await wsUpdate('sale/cuota-categoria-colgate', id, { cuota: value });
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      console.log('Datos devueltos: ', response.data)
      listCuotaDetail();
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    getCuota(id);
    listCuotaDetail();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={listCuotaDetail}
          grupos_incentivos={cuotas}
          softy_grupo_id={id}
        />
      ) : undefined}

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard permission={ConstantPermissions[permission.store]}
              component={
                <CardIcon color="primary">
                  <FileCopySharp style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de grupos de incentivos detallado
            <span style={{ fontSize: '14px' }}>
              <b>{` (${cuotas.description || ''})`}</b>
            </span>
            {dataLoading && <LoadingSpinner />}
            </h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="cuotas_categoria_colgate"
              formatDate="DD-MM-YYYY"
              columns={columns}
              data={cuotasDetail.map((item, i) => {
                const noAssignedBag = (
                  <div className="actions-center">
                    <Badge color="info">No asignado</Badge>
                  </div>
                );
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions[permission.delete]}>
                        <ButtonDelete
                          entity="sale/softy-grupo-detalle"
                          id={item.id}
                          
                          reload={() => {
                            setDataLoading(true);
                            listCuotaDetail().then(() => setDataLoading(false));
                        }}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  periodo: item.periodo,
                  categoria: item.categoria ?? noAssignedBag,
                  linea: item.linea ?? noAssignedBag,
                  familia: item.familia ?? noAssignedBag,
                  producto: item.producto ?? noAssignedBag,
                  type: item.type === 'T' ? 'Todos' : 'Normal',
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
